import { request } from './client';
import type { ImportResult } from './types';

/** Imports an Anki package (.apkg or .colpkg) into new decks. */
export function importAnki(file: File): Promise<ImportResult> {
  const form = new FormData();
  form.append('file', file);

  return request<ImportResult>('/imports/anki', { method: 'POST', body: form });
}

/** Imports a CSV or TSV table into a new deck. */
export function importTable(
  file: File,
  options: { title: string; header: boolean },
): Promise<ImportResult> {
  const form = new FormData();
  form.append('file', file);
  form.append('title', options.title);
  form.append('header', String(options.header));

  return request<ImportResult>('/imports/csv', { method: 'POST', body: form });
}
